var map = {
	"./HK/banner-tablet.png": "pgV1",
	"./MY-DIGI/banner-tablet.png": "1MqT",
	"./MY/banner-tablet.png": "sohY",
	"./PH/banner-tablet.png": "sB03",
	"./TW/banner-tablet.png": "NoI4"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "cmOk";